import { Box, Paper, Stack } from '@mui/material';
import { colors, IconButton, Typography } from '@sweep-io/sweep-design';
import React from 'react';
import { useHandleCommentsAndAiFirst } from '../left-menu/useHandleCommentsAndAiFirst';
import { usePanels } from '../../../../panels/usePanels';
import { importFunnelPanelType } from '../../../funnel-map-flow/dialogs/import-funnel/importFunnelPanelType';
import { templatesPanelType } from '../../../funnel-map-flow/templates/dialog/panelTypes';
import { Close, CloudArrowDown, EditAI, Table } from '@sweep-io/sweep-design/dist/icons';
import { processMiningPanelType } from '../process-mining/processMiningPanelType';

const ZeroStateItem = ({
  icon,
  onClick,
  title,
  description,
}: {
  icon: React.ReactNode;
  onClick: () => void;
  title: string;
  description: string;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1,
        borderBottom: `1px solid ${colors.grey[300]}`,
        backgroundColor: colors.white,
        justifyContent: 'flex-start',
        cursor: 'pointer',
        padding: 2,
        '&:last-child': {
          borderBottom: 'none',
        },
        '&:hover': {
          backgroundColor: colors.grey[100],
        },
        paddingRight: 4,
      }}
      onClick={onClick}
    >
      <Box marginTop="3px"> {icon}</Box>

      <Stack gap={0.5}>
        <Typography variant="body" color={colors.grey[900]}>
          {title}
        </Typography>
        <Typography variant="caption" color={colors.grey[700]}>
          {description}
        </Typography>
      </Stack>
    </Box>
  );
};

export const ZeroStateRightPanel = ({ onClose }: { onClose: () => void }) => {
  const handleCommentsAndAiFirst = useHandleCommentsAndAiFirst();
  const { maybeOpenPanel } = usePanels();

  return (
    <Box
      sx={{
        position: 'fixed',
        right: '40px',
        top: 'calc(50% - 264px)',
        zIndex: 1,
      }}
    >
      <Paper
        sx={{
          width: '384px',
          border: `1px solid ${colors.grey[300]}`,
          backgroundColor: colors.grey[100],
          boxSizing: 'border-box',
          borderRadius: '8px',
          padding: 0,
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            right: '0',
            top: '-34px',
          }}
        >
          <IconButton variant="system" size="tiny" onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
        <Stack spacing={0}>
          <ZeroStateItem
            icon={<EditAI variant="default" color={colors.blue[500]} />}
            onClick={() => {
              handleCommentsAndAiFirst(() => {
                maybeOpenPanel({ panelType: processMiningPanelType });
              });
            }}
            title="Map Your Business Process"
            description="Select an object and AI will trace its process across the org"
          />
          <ZeroStateItem
            icon={<CloudArrowDown variant="default" color={colors.blue[500]} />}
            onClick={() => {
              handleCommentsAndAiFirst(() => {
                maybeOpenPanel({ panelType: importFunnelPanelType });
              });
            }}
            title="Add Record Type from Salesforce"
            description="Bring in your existing funnel directly from your Salesforce setup"
          />
          <ZeroStateItem
            icon={<Table variant="default" color={colors.blue[500]} />}
            onClick={() => {
              handleCommentsAndAiFirst(() => {
                maybeOpenPanel({ panelType: templatesPanelType });
              });
            }}
            title="Use a Sweep template"
            description="Start fast with a pre-built funnel template designed for your team"
          />
        </Stack>
      </Paper>
    </Box>
  );
};
